// extracted by mini-css-extract-plugin
export var emptyButton = "styles-module--emptyButton--3qKws";
export var emptyButtonFull = "styles-module--emptyButtonFull--2Tzst";